// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"HJ-z","smallCardRow":"IJ-z","largeCardRow":"JJ-z","productSearchRow":"KJ-z","curatedRow":"LJ-z"};